import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  Flex,
  Grid,
  GridCol,
  Group,
  Kbd,
  Modal,
  NumberFormatter,
  Pagination,
  ScrollArea,
  Select,
  Switch,
  Table,
  Text,
  Textarea,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
  useMediaQuery,
} from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import {
  IconArrowLeft,
  IconCheck,
  IconGripVertical,
  IconMaximize,
  IconMaximizeOff,
  IconPlus,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import cx from "clsx";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { useNavigate, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import classes from "../../../_base/component/_layout/TableScrollArea.module.css";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { styleCellTable } from "../../../_setup/navdata/baseStyleCellTable";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import classesButton from "../Bill/buttonDisible.module.css";
import PrintReceipts from "../Bill/ListReceipts/PrintReceipts/PrintReceipts";
import {
  DepartmentUser,
  DetailsOrderHeader,
  FundDetails,
  SearchParams,
  UserData,
} from "../PaymentReceipt/model/modelPaymentReceipt";

// New API item interface (do not remove existing `Receipt` in model)
export interface CongNoOrderItem {
  maCn: string;
  deparmentCode: string;
  deparmentName: string;
  maKh: string;
  tenKh: string;
  maDtcn: string;
  telephoneNumber: string;
  soHd: string; // số hợp đồng / số đơn hàng
  ngayTao: string;
  ngayHoanThanh?: string | null;
  trangThaiDon?: string | null;
  tienDonHang: number;
  tienCk: number;
  tienGg: number;
  tienCkGg: number;
  tienBan: number;
  tienVon: number;
  tienDaTra: number;
  conNo: number; // số tiền còn lại
  maNguoiDuyet?: string | null;
  tenNguoiDuyet?: string | null;
  nvKd?: string | null;
  nguoiHuongSo?: string | null;
  id?: number;
  attribute1?: string | null;
  attribute2?: string | null;
}

type ReceiptOrApi = CongNoOrderItem;

// New TblBienBan API interfaces
export interface BienBanRequest {
  bienBan: {
    id: number;
    maBienBan: string;
    nguoiNopTien: number;
    nguoiNhanTien: number;
    maChiNhanh: number;
    tongTien: number;
    createdAt: string;
    createdBy: number;
    lastUpdatedAt: string;
    lastUpdatedBy: number;
    createdByBranch: number;
    createdByDepartment: number;
    createdByRole: number;
    createdByWorkPosition: string;
    note: string | null;
  };
  chiTiet: Array<{
    id: number;
    maDonHang: string;
    tienConNo: number;
    tienDaTra: number;
    tienDonHang: number;
    nguoiHuongSo: string;
    nhanVienKinhDoanh: string;
    maPhongBan: string;
    ngayTao: string;
    createdAt: string;
    createdBy: number;
    lastUpdatedAt: string;
    lastUpdatedBy: number;
    maBienBan: string;
  }>;
}

export interface UserDataInterface {
  id: number;
  code: string;
  fullname: string;
  dateOfBirth: string;
  gender: number | null;
  departmentId: number | null;
  departmentCode: string | null;
  departmentName: string;
  roleId: number | null;
  roleName: string;
  managerName: string | null;
  address: string | null;
  phoneNumber: string;
  active: boolean;
  email: string;
  description: string | null;
  accountingCenterId: number | null;
  managerId: number | null;
  isCrm: boolean | null;
  currentCardId: number | null;
  partCode: string | null;
  createDate: string;
  listBranch: any[] | null;
  listInventory: any[] | null;
  listGroup: any[] | null;
  branchId: number | null;
  brachName: string | null;
  workAddress: string | null;
  listDepartment: any[] | null;
  attribute1: any;
  attribute2: any;
  attribute3: any;
  attribute4: any;
  attribute5: any;
  attribute6: any;
  attribute7: any;
  attribute8: any;
  attribute9: any;
  attribute10: any;
  isAccountant: boolean | null;
  isInventory: boolean | null;
}

export interface CongNoData {
  totalConNo: number;
  totalTienBan: number;
  totalTienCk: number;
  totalTienGg: number;
  totalTienCkGg: number;
  totalTienDaTra: number;
  totalTienDonHang: number;
  totalTienVon: number;
  totalCount: number | null;

  lists: CongNoOrderItem[] | null;
  count: number;
}

export const HandoverSlipCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const maBienBanFromState = (location.state as any)?.maBienBan;
  const [opened, { open, close }] = useDisclosure(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [height, setHeight] = useState(0);
  const [rowCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [heightContent, setHeightContent] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const [branchAll, setBranchAll] = useState<DepartmentUser[]>([]);
  const [dataListBranchOrder, setDataListBranchOrder] = useState<any>();
  const [dataAlloation, setDataAlloation] = useState(false);
  const [totalAllocatedAmount, setTotalAllocatedAmount] = useState<any>(0);
  const [dataListReceipt, setDataListReceipt] = useState<ReceiptOrApi[]>([]);
  const [dataListBranch, setDataListBranch] = useState<ReceiptOrApi[]>([]);

  const [tempSelectedItems, setTempSelectedItems] = useState<ReceiptOrApi[]>(
    []
  );
  const [finalSelectedItems, setFinalSelectedItems] = useState<ReceiptOrApi[]>(
    []
  );

  const [completeTime, setCompleteTime] = useState<Date | null>(null);

  const [selectPayertype, setSelectPayertype] = useState(false);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const [modalPage, setModalPage] = useState<number>(1);
  const [modalPageSize, setModalPageSize] = useState<number>(11);
  const [modalTotal, setModalTotal] = useState<number>(0);
  const [valueTotalAmount, setValueTotalAmout] = useState<any>(null);
  const [valueTotalAmountPaid, setValueTotalAmoutPaid] = useState<any>(null);
  const [changeValueTotal, setChangeValueTatal] = useState<any>(0);
  const [dataGetReceiptParent, setDataGetReceiptParent] = useState<any>();
  const [listdata, setListData] = useState<FundDetails>();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [badgeContent, setBadgeContent] = useState<string>(
    "Số tiền không xác định"
  );
  const [badgeColor, setBadgeColor] = useState<string>("gray");
  const [badIcon, setBadIcon] = useState<React.ReactNode>(null);
  const today = new Date();
  const [isError] = useState(false);
  const [isLoading] = useState(false);
  const [isRefetching] = useState(false);
  const [sorting] = useState<MRT_SortingState>([]);
  const userName = localStorage.getItem("userLogin") || "";
  const [statusReponse, setStatusReponse] = useState<any>();
  const [listEmployeeID, setListEmployeeID] = useState<UserDataInterface[]>([]);

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [inputValues, setInputValues] = useState<{ [key: number]: any }>({});
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isRunning, setIsRunning] = useState<boolean>(true);
  const [stoppedTime, setStoppedTime] = useState<Date | null>();
  const [branchDeparment, setBranchDeparment] = useState<DepartmentUser>();
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [debouncedChangeValueTotal] = useDebouncedValue(changeValueTotal, 500);
  const [debouncedChangeValueAmout] = useDebouncedValue(
    totalAllocatedAmount,
    500
  );
  const [showBadge, setShowBadge] = useState<boolean>(true);
  const [handelDateCurrent, setHandelDateCurrent] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [dataOrderDetail, setDataOderDetailHeader] = useState<
    DetailsOrderHeader[]
  >([]);
  const [groupData, setGroupData] = useState({
    id: dataGetReceiptParent?.attribute2?.id || "",
    groupName: dataGetReceiptParent?.attribute2?.groupName || "",
    groupCreateByName: dataGetReceiptParent?.attribute2?.createByName || "",
  });
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const isSmallScreen = useMediaQuery("(max-width: 900px)", true, {
    getInitialValueInEffect: false,
  });
  const [currentTime, setCurrentTime] = useState<Date | null>();
  const [inputValue, setInputValue] = useState("");
  const [isCollapse, { toggle: toggleCollapse }] = useDisclosure(false);

  const [advancedFilters, setAdvancedFilters] = useState({
    fromDate: null as Date | null,
    toDate: null as Date | null,
    departmentCode: "",
    createdTicket: "N",
    custCode: "",
    telephoneNumber: "",
    orderStatus: "",
    branchCode: "",
    employeeCode: "",
  });
  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];
  const [currentDate, setCurrentDate] = useState<string>("");
  const [formErrors, setFormErrors] = useState({
    payerfullname: "",
    accountfund: "VNĐ",
    codefund: "",
    createby: 0,
    anothername: "",
    createdDate: "",
    creatorbranch: "",
    creatordepartment: "424",
    creatorfullname: "",
    creatorsalesbranch: "",
    creatorworkplace: "",
    fundbranch: "",
    funddepartment: "",
    fundsalesbranch: "",
    fundworkplace: "",
    funfullname: "",
    id: 0,
    note: "",
    nguoiNhanTien: "",
    payernote: "",
    payertype: "",
    receiptNumber: "",
    totalAmount: 0,
    type: 0,
  });
  const componentRef = React.useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
        @page{
          size: A4;
           margin: 7mm 0 7mm 0;
        }
        body:{
          margin: 0;
          color: #000;
        }`,
    // onBeforePrint: () => console.log("Before printing..."),
    // onAfterPrint: () => console.log("After printing..."),
  });
  const handleReturnPage = () => {
    navigate(-1);
  };

  // Helper getters to support both legacy `Receipt` and new `CongNoOrderItem` shapes
  const getOrderNumber = (item: ReceiptOrApi | any): string => {
    return (item?.soHd as string) ?? "";
  };

  const getId = (item: ReceiptOrApi | any): string | number => {
    return item?.id ?? getOrderNumber(item) ?? "";
  };

  const getAmountTotal = (item: ReceiptOrApi | any): number => {
    return Number(item?.tienDonHang ?? 0);
  };

  const getAmountPaid = (item: ReceiptOrApi | any): number => {
    return Number(item?.tienDaTra ?? 0);
  };

  const getAmountRemaining = (item: ReceiptOrApi | any): number => {
    return Number(item?.conNo ?? 0);
  };

  const columns = React.useMemo<MRT_ColumnDef<DetailsOrderHeader>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        enableColumnActions: false,
        enableEditing: false,
        enableSorting: false,
        size: 50,
        Cell: ({ renderedCellValue, row }: any) => (
          <Text fw={600}>{row.index + 1}</Text>
        ),
      },
      {
        accessorKey: "soHd",
        header: "Số đơn hàng",
        enableColumnActions: false,
        enableSorting: false,
        enableEditing: false,
        Cell: ({ renderedCellValue, cell, row }) => (
          <Tooltip label="Xem chi tiết (Chức năng đăng cập nhật)">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              onDoubleClick={() => handleCheckView(row)}
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "tienDaTra",
        header: "Tiền bàn giao",
        enableColumnActions: false,
        enableSorting: false,
        enableEditing: false,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <NumberFormatter
              thousandSeparator
              value={getAmountPaid(row.original)}
            ></NumberFormatter>
          </>
        ),
      },
      {
        accessorKey: "tienBan",
        header: "Tiền hóa đơn",
        enableEditing: false,
        enableSorting: false,
        enableColumnActions: false,

        Cell: ({ renderedCellValue, row }) => (
          <>
            <NumberFormatter
              style={{ textAlign: "center" }}
              thousandSeparator
              value={getAmountTotal(row.original)}
            ></NumberFormatter>
          </>
        ),
      },

      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        enableColumnActions: false,
        enableSorting: false,
        enableEditing: false,
        Cell: ({ row }) => (
          <Text>
            {(row.original as any)?.ngayTao
              ? moment((row.original as any).ngayTao).format("DD-MM-YYYY HH:mm")
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Xóa",
        enablePinning: false,
        size: 60,
        enableSorting: false,
        enableColumnActions: false,
        enableEditing: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Flex justify="center">
            <Tooltip label="Xóa đơn">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                disabled={statusReponse}
                onClick={() => deleteInvoice(getOrderNumber(row.original))}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [
      validationErrors,
      finalSelectedItems,
      dataAlloation,
      inputValues,
      statusReponse,
    ]
  );

  const table = useMantineReactTable<any>({
    columns,
    data: finalSelectedItems,
    positionToolbarAlertBanner: "bottom",
    createDisplayMode: "row",
    editDisplayMode: "cell",
    enableEditing: true,
    enableBatchRowSelection: true,
    enableBottomToolbar: true,
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
          mb={"xs"}
          style={{ opacity: 0 }}
        ></Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },

    mantineBottomToolbarProps: {
      style: {
        display: "none",
      },
    },

    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: {
        maxHeight: height - 95,
        minHeight: height - 95,
        // borderTop: `5px solid #ec1c24`,
      },
    },
    mantineTableProps: {
      striped: true,
    },
    enablePinning: true,
    initialState: {
      columnPinning: {
        left: ["mrt-row-select", "mrt-row-actions"],
        right: ["amountRemaining", "key", "action"],
      },
      showColumnFilters: false,
      columnVisibility: { id: false },
      density: "xs",
    },
    positionActionsColumn: "last",
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: false,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleCellTable(row),
    }),
    onCreatingRowCancel: () => setValidationErrors({}),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    enableColumnPinning: true,
  });

  const handleCheckView = async (row: any) => {
    if (!row || !row.original) {
      console.error("Row or row.original is null or undefined");
      return;
    }

    const orderNumber = getOrderNumber(row.original);
    if (!orderNumber) {
      console.error("Số thứ tự là null hoặc không xác định");
      return;
    }
    const url = `/api/v1/CreateSellItem/details?orderNumber=${orderNumber}`;
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id ?? getId(row.original),
            orderNumber: orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      } else {
        console.error("Lỗi khi lấy thông tin chi tiết đơn hàng", response);
      }
    } catch (error) {
      console.error("Lỗi khi lấy thông tin chi tiết đơn hàng", error);
    }
  };

  const getDataFromLocalStorage = (key: string): UserData | null => {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  };

  const managerOrder = () => (
    <>
      <ScrollArea pr={16} scrollbars="y" h={height + 60} offsetScrollbars>
        <Grid>
          <GridCol pb={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex mt={10} align="center" gap="xs">
              <Text style={{ flex: "0 0 100px", whiteSpace: "nowrap" }}>
                Mã phiếu bàn giao
              </Text>
              <Text fw={500}>{dataGetReceiptParent?.receiptNumber || ""}</Text>
            </Flex>
          </GridCol>
          <GridCol pb={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex mt={10} align="center" gap="xs">
              <Text style={{ flex: "0 0 100px", whiteSpace: "nowrap" }}>
                Thời gian tạo
              </Text>
              <Text fw={500} style={{ whiteSpace: "nowrap" }}>
                <>{moment(currentTime).format("DD-MM-YYYY HH:mm:ss")}</>
              </Text>
            </Flex>
          </GridCol>
          {/* <GridCol
            pb={0}
            offset={{ base: 0, md: 0, lg: 6 }}
            span={{ base: 12, md: 12, lg: 6 }}
          >
            <Flex align="center" gap="xs">
              <Text style={{ flex: "0 0 150px", whiteSpace: "nowrap" }}>
                Thời gian hoàn thành
              </Text>
              <Text fw={500} style={{ whiteSpace: "nowrap" }}>
                {handelDateCurrent && statusReponse ? (
                  <>{moment(completeTime).format("DD-MM-YYYY HH:mm:ss")}</>
                ) : null}
              </Text>
            </Flex>
          </GridCol> */}
          <Grid.Col pt={0} pb={0} span={12}>
            <Divider
              my="xs"
              label={
                <Text size="lg" fw={600} c="#000">
                  Người lập phiếu bàn giao
                </Text>
              }
              labelPosition="left"
            />
          </Grid.Col>
          <Grid.Col pt={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex>
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                Chi nhánh
              </Text>
              <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                {userData?.branchName || (userData as any)?.brachName || ""}
              </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col pt={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex>
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                Họ và tên
              </Text>
              <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                {`${userData?.fullname ?? ""}`}
              </Text>
            </Flex>
          </Grid.Col>

          <GridCol pt={0} pb={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex>
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                ĐĐ làm việc
              </Text>
              <Text fw={600}>{userData?.workAddress ?? ""}</Text>
            </Flex>
          </GridCol>
          <Grid.Col pt={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex>
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                Chức danh
              </Text>
              <Text fw="600">{userData?.roleName}</Text>
            </Flex>
          </Grid.Col>
          <Grid.Col pt={0} span={{ base: 12, md: 12, lg: 6 }}>
            <Flex>
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                Phòng ban
              </Text>
              <Text fw={600} style={{ whiteSpace: "nowrap" }}>
                {userData?.departmentName ?? ""}
              </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col pt={0} span={{ base: 12, md: 12, lg: 6 }}></Grid.Col>
          {/* Người nộp tiền - Divider */}
          <Grid.Col pb={0} pt={0} span={{ base: 12, md: 6 }}>
            <Divider
              my="xs"
              label={
                <Text size="lg" fw={600} c="#000">
                  Người nộp tiền
                </Text>
              }
              labelPosition="left"
            />
          </Grid.Col>

          {/* Người được bàn giao - Divider */}
          <Grid.Col pb={0} pt={0} span={{ base: 12, md: 6 }}>
            <Divider
              my="xs"
              label={
                <Text size="lg" fw={600} c="#000">
                  Người được bàn giao
                </Text>
              }
              labelPosition="left"
            />
          </Grid.Col>
          {/* Người được bàn giao - Loại */}

          {/* Người nộp tiền - Họ và tên */}
          <GridCol pt={0} span={{ base: 6, md: 6 }}>
            <Group style={{ flexWrap: "nowrap" }}>
              <Text style={{ flex: "0 0 90px", whiteSpace: "nowrap" }}>
                Họ và tên <span style={{ color: "red" }}>*</span>
              </Text>
              <Select
                searchable
                clearable
                flex={1}
                readOnly={statusReponse}
                placeholder="Vui lòng chọn tên"
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                limit={50}
                data={listEmployeeID.slice(1).map((item) => {
                  return {
                    label: item.fullname + " - " + item.code,
                    value: String(item.id ?? null),
                  };
                })}
                error={formErrors.funfullname}
                onChange={(selectedDescription) => {
                  if (!selectedDescription) {
                    // Clear payer and dependent selections/data (keep in sync with CN bán clear behavior)
                    handleChange("funfullname", "");
                    setAdvancedFilters((prev) => ({
                      ...prev,
                      employeeCode: "",
                      branchCode: "",
                    }));
                    // Clear branch-related selections and modal lists
                    handleChange("creatorsalesbranch", "");
                    setDataListBranchOrder(undefined);
                    setDataListReceipt([]);
                    setFinalSelectedItems([]);
                    setTempSelectedItems([]);
                    setInputValue("");
                  } else {
                    const selectedOption = listEmployeeID.find(
                      (item) => String(item.id) === String(selectedDescription)
                    );
                    if (selectedOption) {
                      handleChange("funfullname", selectedOption.id);
                    }
                  }
                }}
              />
            </Group>
          </GridCol>

          {/* Người được bàn giao - Họ và tên */}
          <GridCol pt={0} span={{ base: 6, md: 6 }}>
            <Group style={{ flexWrap: "nowrap" }}>
              <Text style={{ flex: "0 0 90px", whiteSpace: "nowrap" }}>
                Họ và tên <span style={{ color: "red" }}>*</span>
              </Text>
              <Select
                searchable
                clearable
                flex={1}
                error={formErrors.nguoiNhanTien}
                readOnly={statusReponse}
                placeholder="Vui lòng chọn tên"
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                limit={50}
                data={listEmployeeID.slice(1).map((item) => {
                  return {
                    label: item.fullname + " - " + item.code,
                    value: String(item.id ?? null),
                  };
                })}
                onChange={(selectedDescription) => {
                  if (!selectedDescription) {
                    setFormData((prev) => ({ ...prev, nguoiNhanTien: 0 }));
                    setFormErrors((prev) => ({ ...prev, nguoiNhanTien: "" }));
                  } else {
                    const selectedOption = listEmployeeID.find(
                      (item) => String(item.id) === String(selectedDescription)
                    );
                    if (selectedOption) {
                      handleChange(
                        "nguoiNhanTien",
                        Number(selectedOption.id) || 0
                      );
                    }
                  }
                }}
              />
            </Group>
          </GridCol>
          {/* Người nộp tiền - CN bán */}
          <GridCol pt={0} span={{ base: 6, md: 6 }}>
            <Flex align="center">
              <Text style={{ flex: "0 0 110px", whiteSpace: "nowrap" }}>
                CN bán <span style={{ color: "red" }}>*</span>
              </Text>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flex: 1,
                }}
              >
                <Select
                  key={
                    String(formData.funfullname) || String(formData.payertype)
                  }
                  searchable
                  clearable
                  disabled={formData.funfullname ? false : true}
                  readOnly={statusReponse}
                  flex={1}
                  placeholder="Vui lòng chọn CN bán"
                  data={(listBranch || []).map((e) => ({
                    label: e.name,
                    value: String(e.id),
                  }))}
                  value={String(formData.creatorsalesbranch) || ""}
                  onChange={(selectedValue) => {
                    if (!selectedValue) {
                      handleChange("creatorsalesbranch", "");
                      setAdvancedFilters((prev) => ({
                        ...prev,
                        branchCode: "",
                      }));
                      setDataListBranchOrder(undefined);
                      setDataListReceipt([]);
                      setFinalSelectedItems([]);
                      setTempSelectedItems([]);
                      // ensure modal is closed when branch cleared
                      close();
                      return;
                    }

                    const selectedOption = listBranch?.find(
                      (item) => String(item.id) === String(selectedValue)
                    );
                    if (selectedOption) {
                      handleChange("creatorsalesbranch", selectedOption.id);
                      setAdvancedFilters((prev) => ({
                        ...prev,
                        branchCode:
                          selectedOption.code ?? String(selectedOption.id),
                      }));
                    }
                  }}
                  allowDeselect={false}
                />
                <ActionIcon
                  variant="light"
                  color="blue"
                  disabled={statusReponse}
                  onClick={() => {
                    if (!formData.creatorsalesbranch) {
                      notifications.show({
                        title: "Thông báo",
                        message: "Vui lòng chọn CN bán trước khi chọn hóa đơn.",
                        color: "red",
                        autoClose: 2000,
                      });
                      return;
                    }
                    open();
                    setDataListBranchOrder(formData.creatorsalesbranch);
                  }}
                >
                  <IconSearch size={16} />
                </ActionIcon>
              </div>
            </Flex>
          </GridCol>
          <GridCol span={{ base: 12, md: 6 }}></GridCol>
          {/* Người nộp tiền - Nội dung */}
          <GridCol span={{ base: 12, md: 12 }}>
            <Group>
              <Text style={{ flex: "0 0 90px", whiteSpace: "nowrap" }}>
                Ghi chú
              </Text>
              <Textarea
                size="sm"
                flex={1}
                rows={3}
                readOnly={statusReponse}
                value={formData.note ?? ""}
                placeholder="Nhập nội dung"
                onChange={(e) => handleChange("note", e.currentTarget.value)}
              />
            </Group>
          </GridCol>

          {/* Người được bàn giao - Nội dung */}
          {/* Tổng tiền */}
          <GridCol span={{ base: 12, md: 6 }}>
            <Group>
              <Text
                style={{ flex: "0 0 90px", whiteSpace: "nowrap" }}
                fw={600}
                c="red"
              >
                Tổng tiền
              </Text>
              <Box style={{ color: "red" }}>
                <NumberFormatter
                  thousandSeparator
                  value={Number(valueTotalAmountPaid) || 0}
                />{" "}
                VND
              </Box>
            </Group>
          </GridCol>
        </Grid>
        <Flex mt={20} align="end" gap={15}>
          <Button
            className={classesButton.button}
            variant="outline"
            color="green"
            disabled={valueTotalAmountPaid === 0 || statusReponse}
            onClick={() => {
              handleComplete();
              fetchCreateReceiptParent(true);
              onChangeTimeCurrent();
            }}
            leftSection={<IconCheck size={14} />}
          >
            Xác nhận
          </Button>
        </Flex>
      </ScrollArea>
    </>
  );

  const fetchData = async () => {
    await fetchDataListReceipt();
  };

  const allSum = () => {
    const totalAmount = finalSelectedItems.reduce((sum, item) => {
      return sum + getAmountTotal(item);
    }, 0);

    const totalAmountPaid = finalSelectedItems.reduce((sum, item) => {
      return sum + getAmountPaid(item);
    }, 0);

    const totalAmountRemaining = finalSelectedItems.reduce((sum, item) => {
      return (
        sum +
        (!dataAlloation
          ? getAmountRemaining(item) || 0
          : (item as any).computedField || 0)
      );
    }, 0);
    setValueTotalAmout(totalAmount);
    setValueTotalAmoutPaid(totalAmountPaid);
    // Ensure the displayed/posted "Tổng tiền" comes from the sum of selected orders
    setChangeValueTatal(totalAmount);
  };

  useEffect(() => {
    allSum();
  }, [finalSelectedItems, dataAlloation]);

  const handleComplete = () => {
    setCompleteTime(new Date());
  };

  const fetchDataGetAll = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentUser[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        const result = response.data;
        setBranchAll(result);
      } else {
        console.error("Failed to fetch departmentFund details");
      }
    } catch (error) {
      console.error("Error fetching departmentFund details", error);
    }
  };

  const fetchDataEmployeeBranchID = async () => {
    const response = await repositoryPos.get<
      MessageResponse<UserDataInterface[]>
    >(`/api/v1/TblDmEmployee/get-all`);

    if (response && response.success) {
      let result = response.data;
      setListEmployeeID(result);
    }
  };

  const deleteInvoice = (value: string) => {
    const filterItems = (items: ReceiptOrApi[]) =>
      items.filter((item) => String(getOrderNumber(item)) !== String(value));

    const updatedFinalItems = filterItems(finalSelectedItems);
    const updatedTempItems = filterItems(tempSelectedItems);

    setFinalSelectedItems(updatedFinalItems);
    setTempSelectedItems(updatedTempItems);

    const newTotal = updatedFinalItems.reduce(
      (acc, item) => acc + (Number((item as any).allocatedAmount) || 0),
      0
    );
    setTotalAllocatedAmount(newTotal);
  };

  const onChangeTimeCurrent = () => {
    setHandelDateCurrent(true);
  };

  const handleInputChange = (index: number, field: string, value: any) => {
    const updatedItems = [...finalSelectedItems];

    // Convert value to a numeric format if the field is `allocatedAmount`
    const numericValue =
      field === "allocatedAmount" && typeof value === "string"
        ? parseFloat(value.replace(/,/g, "")) || 0
        : value || 0;

    updatedItems[index] = {
      ...updatedItems[index],
      [field]: numericValue,
    };
    // persist changes and recompute totals
    setFinalSelectedItems(updatedItems);
    const newTotal = updatedItems.reduce(
      (acc, item) => acc + (Number((item as any).allocatedAmount) || 0),
      0
    );
    setTotalAllocatedAmount(newTotal);
  };

  const [formData, setFormData] = useState({
    accountfund: 0,
    codefund: "111101",
    createby: 0,
    createdDate: moment(stoppedTime, "DD-MM-YYYY HH:mm:ss")
      .add(7, "hours")
      .toISOString(),
    completiontime: moment(currentTime, "DD-MM-YYYY HH:mm:ss")
      .add(7, "hours")
      .toISOString(),
    creatorbranch: "",
    creatordepartment: 424,
    creatorfullname: `${userName} - H567`,
    creatorsalesbranch: "",
    creatorworkplace: `${branchDeparment?.address ?? ""}`,
    fundbranch: "",
    funddepartment: "",
    anothername: "",
    fundsalesbranch: "",
    fundworkplace: "",
    note: "",
    payerfullname: "",
    funfullname: "",
    nguoiNhanTien: 0,
    payernote: "",
    payertype: "Nhân viên",
    receiptNumber: dataGetReceiptParent?.receiptNumber,
    totalAmount: changeValueTotal,
    type: 1,
    typeReceipt: dataGetReceiptParent?.typeReceipt,
  });

  const INFO = {
    receiptNumber: listdata?.receiptNumber.toString() ?? "", // Mã số
    creatorbranch:
      dataBranch.find(
        (item) => String(item.value) === String(listdata?.creatorbranch)
      )?.text ?? "", // phòng ban
    creatorworkplace: branchDeparment?.address, // Địa điểm làm việc
    creatordepartment:
      branchAll?.find(
        (item) =>
          String(item.departmentId) === String(listdata?.creatordepartment)
      )?.name ?? "", //Bộ phận
    createrolename: userData?.roleName, //Chức danh
    creatorfullname: userData?.fullname ?? "", // Họ và tên
    funfullname: (() => {
      const data = listEmployeeID?.find(
        (item) => String(item.id) === String(formData.funfullname)
      );
      return data ? `${data.fullname} - ${data.code}` : null;
    })(), // tên người nộp tiền
    detailHeader: dataOrderDetail,
    note: formData?.note, // Nội dung
    anothername: formData?.anothername, // Tên
    totalAmount: changeValueTotal, //TỔng tiền
    type: 1, //Loại phiếu
    typeReceipt: 1, //Kiểu phiếu
  };
  const formatDate = (date: Date | null): string => {
    if (date === null) return "";
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  };

  const validateForm = () => {
    const hasErrors = Object.values(validationErrors).some(
      (error) => error !== undefined
    );
    setIsFormValid(!hasErrors);
  };

  const handleChange = (
    field: string,
    value: string | number | Date | null
  ) => {
    if (field === "funfullname") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        funfullname: value ? "" : "Vui lòng nhập họ và tên",
      }));
    }

    if (field === "nguoiNhanTien") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        nguoiNhanTien: value ? "" : "Vui lòng nhập họ và tên",
      }));
    }

    if (field === "anothername") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        anothername: value ? "" : "Vui lòng nhập họ và tên",
      }));
    }

    if (field === "creatorsalesbranch" && value) {
      // open();
      setDataListBranchOrder(value);
    }

    if (field === "payertype") {
      if (value === "Khách hàng") {
        setSelectPayertype(true);
      } else {
        setSelectPayertype(false);
      }
    }

    if (field === "branch") {
      const matchedObject = dataListBranch.find(
        (element: any) => element.text === value
      );
      if (matchedObject) {
        // setOptions(matchedObject.value);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [field]: value instanceof Date ? value.toISOString() : value,
    }));
    validateForm();
  };

  const filteredDataList = useMemo(() => {
    return (dataListReceipt || []).filter((receipt) => {
      // Filter by search query
      const matchesSearch = getOrderNumber(receipt)
        .toString()
        .toLowerCase()
        .includes((searchQuery || "").toLowerCase());

      const isNotCreatedTicket = (receipt as any)?.createdTicket !== "Y";

      return matchesSearch && isNotCreatedTicket;
    });
  }, [searchQuery, dataListReceipt]);

  const handleCheckboxChange = (item: ReceiptOrApi) => {
    setTempSelectedItems((prevSelectedItems) => {
      const isItemSelected = prevSelectedItems.some(
        (selectedItem) => String(getId(selectedItem)) === String(getId(item))
      );
      return isItemSelected
        ? prevSelectedItems.filter(
            (selectedItem) =>
              String(getId(selectedItem)) !== String(getId(item))
          )
        : [...prevSelectedItems, item];
    });
  };

  const handleConfirm = () => {
    const updatedItems = tempSelectedItems.map((item) => ({
      ...item,
      allocatedAmount: getAmountRemaining(item),
      attribute1: groupData.id,
      attribute2: groupData.groupName,
    }));
    setInputValue(
      (() => {
        const first =
          tempSelectedItems.length > 0 ? tempSelectedItems[0] : null;
        if (!first) return "";
        let nvkdRaw =
          (first as any)?.nvKd ??
          (first as any)?.nvkd ??
          (first as any)?.nhanVienKinhDoanh ??
          (first as any)?.nguoiNhan ??
          (first as any)?.attribute1 ??
          "";

        const emp = listEmployeeID.find(
          (e) =>
            String(e.id) === String(nvkdRaw) ||
            String(e.code) === String(nvkdRaw)
        );
        if (emp) {
          handleChange("funfullname", emp.id);
          return `${emp.id}-${emp.fullname}`;
        }

        return String(nvkdRaw);
      })()
    );
    setFinalSelectedItems(updatedItems);

    const newTotal = tempSelectedItems.reduce(
      (acc, item) => acc + (getAmountRemaining(item) || 0),
      0
    );
    setTotalAllocatedAmount(newTotal);
    close();
  };

  console.log(userData, "ádadasdasdasd");

  const fetchCreateReceiptParent = async (handleSave?: boolean) => {
    // Validation
    let isValid = true;
    const errors = {
      payerfullname: "",
      accountfund: "VND",
      codefund: "",
      createby: 0,
      anothername: "",
      createdDate: "",
      creatorbranch: "",
      creatordepartment: "",
      creatorfullname: "",
      creatorsalesbranch: "",
      creatorworkplace: "",
      fundbranch: "",
      funddepartment: "",
      fundsalesbranch: "",
      fundworkplace: "",
      funfullname: "",
      nguoiNhanTien: "",
      id: 0,
      note: "",
      payernote: "",
      payertype: "",
      receiptNumber: "",
      totalAmount: 0,
      type: 0,
    };

    if (!formData.funfullname) {
      errors.funfullname = "Vui lòng nhập họ và tên!";
      isValid = false;
    }
    if (!formData.nguoiNhanTien) {
      errors.nguoiNhanTien = "Vui lòng nhập họ và tên!";
      isValid = false;
    }

    setFormErrors(errors);

    if (!isValid) {
      notifications.show({
        title: "Thông báo",
        message: "Vui lòng nhập đầy đủ thông tin.",
        autoClose: 3000,
        color: "red",
        icon: <IconX />,
      });
      return;
    }

    setIsRunning(false);

    // Build chiTiet array from finalSelectedItems
    const chiTiet = finalSelectedItems
      .map((item, index) => {
        const orderNum = getOrderNumber(item);
        const total = getAmountTotal(item);
        const paid = getAmountPaid(item);
        const remaining = getAmountRemaining(item);
        const alloc = Number((item as any).allocatedAmount ?? remaining);

        if (!orderNum || total <= 0) return null;

        return {
          id: 0,
          maDonHang: orderNum,
          tienConNo: remaining,
          tienDaTra: paid,
          tienDonHang: total,
          nguoiHuongSo: (item as any)?.nguoiHuongSo ?? "",
          nhanVienKinhDoanh: (item as any)?.nvKd ?? "",
          maPhongBan: (item as any)?.deparmentCode ?? "",
          ngayTao:
            (item as any)?.ngayTao ??
            moment(new Date()).add(7, "hours").toISOString(),
          createdAt: moment(new Date()).add(7, "hours").toISOString(),
          createdBy: userData?.id ?? 0,
          lastUpdatedAt: moment(new Date()).add(7, "hours").toISOString(),
          lastUpdatedBy: userData?.id ?? 0,
          maBienBan: dataGetReceiptParent?.receiptNumber ?? "",
        };
      })
      .filter((item) => item !== null);

    // Build request data for new API
    const requestData: BienBanRequest = {
      bienBan: {
        id: 0,
        maBienBan: dataGetReceiptParent?.receiptNumber ?? "",
        nguoiNopTien: Number(formData.funfullname) || 0,
        nguoiNhanTien: Number(formData.nguoiNhanTien) || 0,
        maChiNhanh: Number(formData.creatorsalesbranch) || 0,
        tongTien: valueTotalAmountPaid,
        createdAt: moment(new Date()).add(7, "hours").toISOString(),
        createdBy: userData?.id ?? 0,
        lastUpdatedAt: moment(new Date()).add(7, "hours").toISOString(),
        lastUpdatedBy: userData?.id ?? 0,
        createdByBranch: Number(userData?.branchId) || 0,
        createdByDepartment: Number(userData?.departmentId) || 0,
        createdByRole: Number(userData?.roleId) || 0,
        createdByWorkPosition: userData?.workAddress ?? "",
        note: formData.note || "",
      },
      chiTiet: chiTiet as any,
    };

    setDataOderDetailHeader(chiTiet as any);

    try {
      const response = await repositoryPos.post<
        MessageResponse<BienBanRequest>
      >("/api/v1/TblBienBan/create", requestData);

      if (response && response.success) {
        // After creating the bien ban, update attribute98 for each related order
        const updateAttribute98 = async (items: ReceiptOrApi[]) => {
          try {
            const orderNumbers = items
              .map((item) => String(getOrderNumber(item) || getId(item) || ""))
              .filter((v) => v);

            const payload = { orderNumber: orderNumbers };

            if (orderNumbers.length === 0) return;

            await repositoryPos.post<MessageResponse<any>>(
              "/api/v1/TblBienBan/update-attribute98",
              payload
            );
          } catch (err) {
            console.error("Error updating attribute98:", err);
          }
        };

        // Await to ensure attribute98 is updated after create
        await updateAttribute98(finalSelectedItems);
        notifications.show({
          title: "Thành công",
          message: handleSave
            ? "Phiếu bàn giao đã được xác nhận thành công!"
            : "Phiếu bàn giao đã được lưu thành công!",
          autoClose: 3000,
          color: "green",
          icon: <IconCheck />,
        });
        setStatusReponse(response.success);
      } else {
        notifications.show({
          title: "Thất bại",
          message: "Lưu phiếu bàn giao không thành công. Vui lòng thử lại!",
          autoClose: 3000,
          color: "red",
          icon: <IconX />,
        });
      }
    } catch (error) {
      console.error("Error creating bien ban:", error);
      notifications.show({
        title: "Lỗi",
        message: "Có lỗi xảy ra khi tạo phiếu bàn giao!",
        autoClose: 3000,
        color: "red",
        icon: <IconX />,
      });
    }
  };
  const fetchDataDepartments = async () => {
    try {
      const response = await repositoryPos.post<
        MessageResponse<DepartmentUser>
      >(`/api/v1/TblDepartment/detail?id=${listdata?.creatordepartment}`);

      if (response && response.success) {
        const result = response.data;
        setBranchDeparment(result);
      } else {
        console.error("Failed to fetch department details", response?.message);
      }
    } catch (error) {
      console.error("Error fetching department details", error);
    }
  };

  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranch(result);
    }
  };

  useEffect(() => {
    if (listdata?.creatordepartment) {
      fetchDataDepartments();
    }
  }, [listdata?.creatordepartment]);

  useEffect(() => {
    if (formData.payertype) {
      setFormData((prevData) => ({
        ...prevData,
        funfullname: "",
      }));
    }
  }, [formData.payertype]);

  useEffect(() => {
    if (finalSelectedItems.length === 0) {
      setDataAlloation(false);
    }
  }, [finalSelectedItems]);

  useEffect(() => {
    const getCurrentDateFormatted = (): string => {
      const today = new Date();
      const day = today.getDate()?.toString().padStart(2, "0");
      const month = (today.getMonth() + 1)?.toString().padStart(2, "0");
      const year = today.getFullYear();

      return `${day}.${month}.${year}`;
    };
    setCurrentDate(getCurrentDateFormatted());
  }, []);

  useEffect(() => {
    validateForm();
  }, [totalAllocatedAmount]);

  const fetchDataListReceipt = async () => {
    if (dataListBranchOrder) {
      // Use Skip/Take pagination as backend expects
      const skip = Math.max(0, (modalPage - 1) * modalPageSize);
      let url = `/api/v1/SaleByCustByOrder/get-list-mobile?Skip=${skip}&Take=${modalPageSize}`;

      if (advancedFilters.fromDate) {
        url += `&FromDate=${formatDate(advancedFilters.fromDate)}`;
      }

      if (advancedFilters.toDate) {
        url += `&ToDate=${formatDate(advancedFilters.toDate)}`;
      }

      if (advancedFilters.departmentCode) {
        url += `&DeparmentCode=${advancedFilters.departmentCode}`;
      }

      if (advancedFilters.custCode) {
        url += `&CustCode=${advancedFilters.custCode}`;
      }

      if (advancedFilters.telephoneNumber) {
        url += `&TelephoneNumber=${advancedFilters.telephoneNumber}`;
      }

      if (advancedFilters.orderStatus) {
        url += `&OrderStatus=${advancedFilters.orderStatus}`;
      }

      if (advancedFilters.branchCode) {
        url += `&BranchCode=${advancedFilters.branchCode}`;
      }

      if (advancedFilters.employeeCode) {
        url += `&Nvkd=${advancedFilters.employeeCode}`;
      }

      url += `&CreatedTicket=${advancedFilters.createdTicket}`;

      try {
        const response = await repositoryPos.get<MessageResponse<CongNoData>>(
          url
        );

        if (response && response.success) {
          const res = response.data as CongNoData | any;
          const list = Array.isArray(res?.lists) ? res.lists : [];
          setDataListReceipt(list as ReceiptOrApi[]);
          const total =
            res?.total ?? res?.totalCount ?? res?.recordsTotal ?? list.length;
          setModalTotal(Number(total || 0));
        }
      } catch (error) {
        console.error("Error fetching data list receipt:", error);
      }
    }
  };

  //#region openConfirmModal
  useEffect(() => {
    setFinalSelectedItems([]);
    setTempSelectedItems([]);
    setAdvancedFilters((prev) => ({
      ...prev,
      employeeCode: prev.employeeCode || "",
      orderStatus: "DON_HANG_HOAN_THANH",
      createdTicket: "N",
      fromDate: new Date(),
      toDate: new Date(),
    }));
    setModalPage(1);
    fetchDataListReceipt();
  }, [dataListBranchOrder]);

  useEffect(() => {
    fetchDataListReceipt();
  }, [modalPage, modalPageSize]);

  useEffect(() => {
    if (!formData.funfullname) {
      setAdvancedFilters((prev) => ({ ...prev, employeeCode: "" }));
      return;
    }

    const emp = listEmployeeID.find(
      (e) => String(e.id) === String(formData.funfullname)
    );
    if (emp) {
      setAdvancedFilters((prev) => ({ ...prev, employeeCode: emp.code || "" }));
    }
  }, [formData.funfullname, listEmployeeID]);

  useEffect(() => {
    setTempSelectedItems([]);
    setFinalSelectedItems([]);
  }, [selectPayertype]);

  useEffect(() => {
    setCurrentTime(new Date());
    fetchDataBranch();
    fetchDataGetAll();
    fetchDataEmployeeBranchID();
  }, []);

  useEffect(() => {
    if (formData.payertype === "Khách hàng") {
      setFormData((prev) => ({
        ...prev,
        anothername: inputValue,
      }));
    }
  }, [inputValue, formData.payertype]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      createdDate: moment(new Date(), "DD-MM-YYYY HH:mm:ss")
        .add(7, "hours")
        .toISOString(),
    }));
  }, []);

  useEffect(() => {
    const fetchDataListBranch = async () => {
      const response = await repositoryDelivery.get<MessageResponse<any[]>>(
        "/api/v1/TblDmMasterOrg/get-select"
      );

      if (response && response.success) {
        let result = response.data;
        setDataListBranch(result);
      }
    };
    const fetchDataBranch = async () => {
      const response = await repositoryDelivery.get<
        MessageResponse<TblDMPaymentMethod[]>
      >("/api/v1/TblDmMasterOrg/get-all");

      if (response && response.success) {
        let result = response.data;
        setListBranch(result);
      }
    };

    Promise.all([fetchDataListBranch(), fetchDataBranch()]);
  }, []);

  const fetchDetailData = async (maBienBan: string) => {
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblBienBan/get-detail?MaBienBan=${maBienBan}`
      );

      if (response && response.success && response.data) {
        const detail = response.data;

        // Set receipt parent data
        setDataGetReceiptParent({
          receiptNumber: detail.maBienBan,
        });

        // Set form data
        setFormData((prev) => ({
          ...prev,
          funfullname: String(detail.nguoiNopTien || ""),
          nguoiNhanTien: Number(detail.nguoiNhanTien) || 0,
          creatorsalesbranch: String(detail.maChiNhanh || ""),
          note: detail.note || "",
          creatorbranch: String(detail.createdByBranch || ""),
          creatordepartment: Number(detail.createdByDepartment) || 0,
          creatorworkplace: detail.createdByWorkPosition || "",
        }));

        // Lookup branch name from dataBranch
        const creatorBranch = dataBranch.find(
          (item) => String(item.value) === String(detail.createdByBranch)
        );

        // Lookup department name from branchAll
        const creatorDepartment = branchAll.find(
          (item) =>
            String(item.departmentId) === String(detail.createdByDepartment)
        );

        // Lookup creator employee info
        const creatorEmployee = listEmployeeID.find(
          (item) => String(item.id) === String(detail.createdBy)
        );

        console.log(creatorBranch?.text, "lookups");

        // Update userData with complete creator information
        setUserData((prev) =>
          prev
            ? {
                ...prev,
                branchId: detail.createdByBranch || prev.branchId,
                branchName: creatorBranch?.text ?? "",
                departmentId: detail.createdByDepartment || prev.departmentId,
                departmentName:
                  creatorDepartment?.name ||
                  detail.createdByDepartmentName ||
                  prev.departmentName,
                roleId: detail.createdByRole || prev.roleId,
                roleName: detail.createdByWorkPosition || prev.roleName,
                fullname:
                  creatorEmployee?.fullname ||
                  detail.createdByName ||
                  prev.fullname,
                workAddress: detail.createdByWorkAddress || prev.workAddress,
              }
            : null
        );

        // Set advanced filters
        if (detail.maChiNhanh) {
          const branch = listBranch?.find(
            (item) => String(item.id) === String(detail.maChiNhanh)
          );
          if (branch) {
            setAdvancedFilters((prev) => ({
              ...prev,
              branchCode: branch.code ?? String(branch.id),
            }));
          }
        }

        // Map orders to finalSelectedItems
        if (detail.orders && Array.isArray(detail.orders)) {
          const mappedOrders = detail.orders.map((order: any) => ({
            id: order.id,
            soHd: order.maDonHang,
            tienConNo: order.tienConNo,
            tienDaTra: order.tienDaTra,
            tienDonHang: order.tienDonHang,
            nguoiHuongSo: order.nguoiHuongSo,
            nvKd: order.nhanVienKinhDoanh,
            deparmentCode: order.maPhongBan,
            ngayTao: order.ngayTao,
          }));

          setFinalSelectedItems(mappedOrders);
          setTempSelectedItems(mappedOrders);
        }

        // Set total amounts
        setValueTotalAmoutPaid(detail.tongTien || 0);
        setChangeValueTatal(detail.tongTien || 0);

        // Mark as response received (read-only mode)
        setStatusReponse(true);
      }
    } catch (error) {
      console.error("Error fetching bien ban detail:", error);
    }
  };

  const fetchDataReceiptParent = async () => {
    const response = await repositoryPos.get(
      "/api/v1/TblBienBan/generate-code"
    );
    if (response) {
      const result = response;
      const maBienBan = result?.code ?? "";
      const mappedData = {
        receiptNumber: maBienBan,
      };
      setDataGetReceiptParent(mappedData);
    }
  };

  useEffect(() => {
    if (maBienBanFromState) {
      fetchDetailData(maBienBanFromState);
    } else {
      fetchDataReceiptParent();
    }
  }, [maBienBanFromState]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const contentHeight = contentRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
      setHeightContent(window.innerHeight - (105 + contentHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [heightContent, height]);

  useEffect(() => {
    const data = getDataFromLocalStorage("userLogin");
    if (data) {
      setUserData(data);
    }
  }, []);

  const isAllSelected =
    (filteredDataList?.length ?? 0) > 0 &&
    tempSelectedItems.length === (filteredDataList?.length ?? 0);

  const handleSelectAllChange = () => {
    if (isAllSelected) {
      setTempSelectedItems([]);
    } else {
      setTempSelectedItems(filteredDataList ?? []);
    }
  };

  useHotkeys([["ctrl+shift+Z", () => toggleCollapse()]]);

  return (
    <>
      <header ref={headerRef}>
        <_breadcrumb></_breadcrumb>
        <Grid pb={15}>
          <GridCol span={{ base: 12, md: 12, lg: 4 }}>
            <Flex align="center" gap={20}>
              <Button
                radius="lg"
                color="blue"
                leftSection={<IconPlus size={14} />}
                variant="filled"
                onClick={() => {
                  navigate("/bill/handover-slip");
                  window.location.reload();
                }}
              >
                Tạo mới
              </Button>
              <Flex align="center" gap={10}>
                <Switch
                  size="lg"
                  color={isCollapse ? "red" : "green"}
                  checked={!isCollapse}
                  onLabel="Bật"
                  offLabel="Tắt"
                  onChange={toggleCollapse}
                  thumbIcon={
                    !isCollapse ? (
                      <IconMaximize
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    ) : (
                      <IconMaximizeOff
                        style={{ width: 16, height: 16 }}
                        stroke={2.5}
                        color="white"
                      />
                    )
                  }
                />
                {
                  <Text size="md">
                    <Kbd>Ctrl</Kbd> + <Kbd>Shift</Kbd> + <Kbd>Z</Kbd>
                  </Text>
                }
              </Flex>
            </Flex>
          </GridCol>
          <GridCol
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            span={{ base: 12, md: 6, lg: 4 }}
          >
            {dataAlloation && showBadge && (
              <Badge
                p={20}
                pt={15}
                pb={15}
                leftSection={badIcon}
                color={badgeColor}
              >
                {badgeContent}
              </Badge>
            )}
          </GridCol>
        </Grid>
      </header>
      <Modal
        size="90rem"
        opened={opened}
        onClose={close}
        p={0}
        title={<Title order={5}>Chọn hóa đơn</Title>}
      >
        <Grid align="center" mt={10}>
          <Group grow wrap="nowrap" style={{ width: "100%" }}>
            <Grid style={{ width: "100%" }}>
              <GridCol span={{ base: 6, md: 4, lg: 2 }}>
                <TextInput
                  size="sm"
                  label="Từ khóa"
                  placeholder="Từ khóa"
                  value={searchQuery}
                  onChange={(event) =>
                    setSearchQuery(event.currentTarget.value)
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </GridCol>
              <GridCol span={{ base: 6, md: 4, lg: 2 }}>
                <DatePickerInput
                  locale="vi"
                  flex={1}
                  size="sm"
                  label="Từ ngày"
                  clearable
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  value={advancedFilters.fromDate}
                  valueFormat="DD-MM-YYYY"
                  placeholder="Vui lòng chọn từ ngày"
                  onChange={(date) => {
                    setAdvancedFilters((prev) => ({ ...prev, fromDate: date }));
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </GridCol>
              <GridCol span={{ base: 6, md: 4, lg: 2 }}>
                <DatePickerInput
                  locale="vi"
                  flex={1}
                  size="sm"
                  label="Đến ngày"
                  clearable
                  value={advancedFilters.toDate}
                  valueFormat="DD-MM-YYYY"
                  placeholder="Vui lòng chọn đến ngày"
                  onChange={(date) => {
                    setAdvancedFilters((prev) => ({ ...prev, toDate: date }));
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </GridCol>
              {/* <GridCol span={{ base: 6, md: 4, lg: 2 }}>
                <Select
                  size="sm"
                  label="Nhân viên"
                  placeholder="Chọn nhân viên"
                  searchable
                  clearable
                  data={listEmployeeID.slice(1).map((item) => ({
                    label: `${item.fullname} - ${item.code}`,
                    value: String(item.code ?? ""),
                  }))}
                  value={advancedFilters.employeeCode || ""}
                  onChange={(val) => {
                    setAdvancedFilters((prev) => ({
                      ...prev,
                      employeeCode: val ?? "",
                    }));
                    fetchData();
                  }}
                />
              </GridCol> */}
              <GridCol span={{ base: 6, md: 4, lg: 2 }}>
                <Button
                  mt={20}
                  leftSection={<IconSearch size={12} />}
                  onClick={fetchData}
                >
                  Tìm kiếm
                </Button>
              </GridCol>
            </Grid>
          </Group>
        </Grid>
        <ScrollArea
          h={filteredDataList.length > 0 ? 350 : 100}
          onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        >
          <Table
            striped
            horizontalSpacing="sm"
            withTableBorder
            withColumnBorders
          >
            <Table.Thead
              className={cx(classes.header, {
                [classes.scrolled]: scrolled,
              })}
            >
              <Table.Tr>
                <Table.Th ta="center">
                  <Checkbox
                    checked={isAllSelected}
                    onChange={handleSelectAllChange}
                  />
                </Table.Th>
                <Table.Th ta="center">Mã đơn hàng</Table.Th>
                <Table.Th ta="center">Phòng ban</Table.Th>
                <Table.Th ta="center">Khách hàng</Table.Th>
                <Table.Th ta="center">Nhân viên</Table.Th>
                <Table.Th ta="center">Ngày tạo</Table.Th>
                <Table.Th ta="center">Tổng tiền (VND)</Table.Th>
                <Table.Th ta="center">Đã thanh toán (VND)</Table.Th>
                <Table.Th ta="center">Số tiền còn lại (VND)</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {filteredDataList.length === 0 ? (
                <Table.Tr>
                  <Table.Td colSpan={9} ta="center">
                    Không có dữ liệu
                  </Table.Td>
                </Table.Tr>
              ) : (
                filteredDataList?.map((value) => (
                  <Table.Tr key={String(getId(value))}>
                    <Table.Td>
                      <Checkbox
                        checked={tempSelectedItems.some(
                          (selectedItem) =>
                            String(getId(selectedItem)) === String(getId(value))
                        )}
                        onChange={() => handleCheckboxChange(value)}
                      />
                    </Table.Td>
                    <Table.Td ta="start">{getOrderNumber(value)}</Table.Td>
                    <Table.Td ta="start">
                      {(value as any)?.deparmentName ?? ""}
                    </Table.Td>
                    <Table.Td ta="start">
                      {(value as any)?.tenKh ?? ""}
                    </Table.Td>
                    <Table.Td ta="start">{(value as any)?.nvKd ?? ""}</Table.Td>
                    <Table.Td ta="center">
                      {(value as any)?.ngayTao
                        ? moment((value as any).ngayTao).format(
                            "DD-MM-YYYY HH:mm"
                          )
                        : ""}
                    </Table.Td>
                    <Table.Td ta="end">
                      <NumberFormatter
                        thousandSeparator
                        value={getAmountTotal(value)}
                      ></NumberFormatter>
                    </Table.Td>
                    <Table.Td ta="end">
                      <NumberFormatter
                        thousandSeparator
                        value={getAmountPaid(value)}
                      ></NumberFormatter>
                    </Table.Td>
                    <Table.Td ta="end">
                      <NumberFormatter
                        thousandSeparator
                        value={getAmountRemaining(value)}
                      ></NumberFormatter>
                    </Table.Td>
                  </Table.Tr>
                ))
              )}
            </Table.Tbody>
          </Table>
        </ScrollArea>
        <div style={{ width: "100%", display: "flex", justifyContent: "end" }}>
          <Pagination
            value={modalPage}
            onChange={(p) => setModalPage(p)}
            total={Math.max(1, Math.ceil(modalTotal / modalPageSize))}
          />
        </div>
        <Group mt={15} justify="flex-end">
          <Button
            size="sm"
            variant="filled"
            key="confirm"
            onClick={handleConfirm}
            disabled={tempSelectedItems.length === 0}
          >
            Tiếp tục
          </Button>
        </Group>
      </Modal>
      <PanelGroup
        style={{ height: !isSmallScreen ? "100%" : `${height * 2.5}px` }}
        autoSaveId="conditional"
        direction={isSmallScreen ? "vertical" : "horizontal"}
      >
        <Panel
          defaultSize={isSmallScreen ? 60 : 35}
          minSize={isSmallScreen ? 60 : isCollapse ? 0 : 35}
          maxSize={isSmallScreen ? 60 : 50}
          collapsible={!isSmallScreen}
          style={{
            width: isSmallScreen ? "100%" : "auto",
            transform: isCollapse ? "translateX(-10%)" : "translateX(0)",
            display: isCollapse ? "none" : "block",
          }}
        >
          <Card
            shadow="sm"
            radius="md"
            withBorder
            pr={0}
            pt={0}
            p="md"
            style={{
              maxHeight: height + 60,
              minHeight: height + 60,
            }}
          >
            {managerOrder()}
          </Card>
        </Panel>
        {!isCollapse && !isSmallScreen && (
          <PanelResizeHandle
            style={{ position: "relative" }}
            id="resize-handle"
          >
            <Box
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: "100",
              }}
            >
              <ActionIcon
                size="sm"
                radius="md"
                variant="default"
                aria-label="Settings"
              >
                <IconGripVertical size={16} />
              </ActionIcon>
            </Box>
          </PanelResizeHandle>
        )}
        <Panel
          defaultSize={isSmallScreen ? 50 : isCollapse ? 100 : 55}
          minSize={isSmallScreen ? 50 : 35}
          maxSize={isSmallScreen ? 50 : isCollapse ? 100 : 65}
          style={{
            width: isSmallScreen ? "100%" : "auto",
          }}
        >
          <MantineReactTable table={table} />
          <Card
            shadow="sm"
            radius="md"
            withBorder
            p="md"
            mt={5}
            style={{
              backgroundColor: "#f9f9f9",
              borderRadius: "10px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Divider
              pb={20}
              mt={0}
              my="xs"
              label={<Text size="sm">Tổng Kết Số Tiền</Text>}
              labelPosition="left"
              variant="dashed"
            />
            <Grid w="100%">
              <GridCol
                span={{ base: 5.5, md: 6, lg: 2.5 }}
                style={orderInfoStyle}
              >
                <Text
                  size="lg"
                  c="#000"
                  fw={500}
                  lineClamp={1}
                  style={infoLabelStyle}
                >
                  Tổng tiền hóa đơn
                </Text>
                <Text fw={600} size="lg">
                  <NumberFormatter
                    value={valueTotalAmount}
                    thousandSeparator
                    style={infoValueStyle}
                  />
                </Text>
              </GridCol>
              <GridCol
                span={{ base: 5.5, md: 6, lg: 2.5 }}
                style={orderInfoStyle}
              >
                <Text fw={500} lineClamp={1} style={infoLabelStyle}>
                  Tổng tiền bàn giao
                </Text>
                <Text fw={600} size="lg">
                  <NumberFormatter
                    value={valueTotalAmountPaid}
                    thousandSeparator
                    style={infoValueStyle}
                  />
                </Text>
              </GridCol>
            </Grid>
          </Card>
        </Panel>
        <Box style={{ display: "none" }}>
          <PrintReceipts
            componentRef={componentRef}
            currentDate={currentDate}
            dataPrint={INFO}
          />
        </Box>
      </PanelGroup>
    </>
  );
};

const orderInfoStyle = {
  display: "flex",
  flexDirection: "column" as "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center" as "center",
  padding: "10px",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  margin: "5px",
};

const infoLabelStyle = {
  fontSize: "14px",
  color: "#555",
  marginBottom: "5px",
};

const infoValueStyle = {
  fontSize: "14px",
  fontWeight: "bold" as "bold",
};
